var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "appear": "",
      "name": "component-fade"
    }
  }, [_c('div', {
    staticClass: "spnod-admin__form--container container pl-0 mx-0 mb-4"
  }, [(_vm.isDisclaimerDisplayed) ? _c('p', {
    staticClass: "small mb-4 text-primary"
  }, [_vm._v("Thank you for adding this user. Do you want to add additional parents or guardians to this account?")]) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('submitEvent')
      }
    }
  }, [_c('b-form-row', {
    staticClass: "mb-2"
  }, [_c('b-col', [_c('b-form-input', {
    attrs: {
      "name": "firstName",
      "value": _vm.$v.value.firstName.$model,
      "state": _vm.validateState('firstName'),
      "type": "text",
      "placeholder": "First Name",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        return _vm.handleInput('firstName', $event)
      }
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('b-form-input', {
    attrs: {
      "name": "lastName",
      "value": _vm.value.lastName,
      "state": _vm.validateState('lastName'),
      "type": "text",
      "placeholder": "Last Name",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        return _vm.handleInput('lastName', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.value.email,
      "state": _vm.validateState('email'),
      "type": "email",
      "placeholder": "Email",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        return _vm.handleInput('email', $event)
      }
    }
  }), _vm._v(" "), _c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.value.phone,
      "state": _vm.validateState('phone'),
      "type": "tel",
      "placeholder": "Phone Number",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        return _vm.handleInput('phone', $event)
      }
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    staticClass: "mb-2"
  }, [_vm._v("\n          Must follow this format: 8885551234\n        ")])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "d-flex justify-content-between mx-0"
  }, [(_vm.isFirst) ? _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n          Back\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isFirst) ? _c('b-button', {
    staticClass: "bg-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('updateEvent', 'remove', _vm.$vnode.key)
      }
    }
  }, [_vm._v("\n          Remove\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isLast) ? _c('b-form-group', {
    staticClass: "d-flex flex-grow justify-content-end mb-0"
  }, [(_vm.forClient) ? _c('router-link', {
    attrs: {
      "to": "/user/payment"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "button",
      "size": "sm"
    }
  }, [_vm._v("Skip")])], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "button",
      "size": "sm",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('updateEvent', 'add')
      }
    }
  }, [_vm._v("\n            Add\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.disableSubmit
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Submit")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a552d8cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/ParentForm.vue
// module id = 1Tu5
// module chunks = 2